/**
 * Normalizes the given pool string to a pool host.
 * @arg pool The pool to normalize.
 * @returns A string that represents the normalized pool.
 */
export function normalizePool(pool: string) {
  return pool.replace(/^http(s)?:\/\//, '').replace(/^dev\./, '');
}

/**
 * Checks if the provided Bixel pool is valid by matching it to bixel.io or bixel/quaxel###.net.
 * @arg pool The pool host to validate.
 * @returns true if the pool is valid, false otherwise.
 */
export function isValidPool(pool: string) {
  if (/bixel.io$/.test(pool)) {
    return true;
  }

  return /(bixel|quaxel)\d+\.net$/.test(pool);
}
